import { useEffect } from "react";
import { Outlet, createFileRoute } from "@tanstack/react-router";

import { registerWorkspaceHeader } from "../../../lib/nav";
import { useProjectAddress } from "../../../shell/project";
import { simulateNav } from "../../../workspaces/worlds/nav";

export const Route = createFileRoute(
  "/_console/p/$org/$project/build-worlds",
)({
  component: BuildWorldsLayout,
});

function BuildWorldsLayout() {
  const address = useProjectAddress();
  useEffect(
    () =>
      registerWorkspaceHeader({
        workspace: "world-authoring",
        items: simulateNav(address),
        presentation: "tabs",
      }),
    [address],
  );
  return <Outlet />;
}
